import { render, staticRenderFns } from "./EventDetailDialog.vue?vue&type=template&id=7bada4bc&scoped=true"
import script from "./EventDetailDialog.vue?vue&type=script&lang=js"
export * from "./EventDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./EventDetailDialog.vue?vue&type=style&index=0&id=7bada4bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bada4bc",
  null
  
)

export default component.exports